import {getProductInsurersPlanList} from '@api/common'

export default {
  data(){
    const checkSelectPlan = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      let {plan_id} = this.item||{}
      if(!plan_id) {
        callback(new Error('Please select'))
      }
      callback()
    }
    return{
      currentPlanList:[],
      rules:{
        item_plan_id: [
          { validator: checkSelectPlan, trigger: ['change', 'blur'] }
        ],
      },
    }
  },
  watch: {
    'item.company_id':{
      immediate: true,
      deep: true,
      handler(val){
        if(val){
          this.changeOtherProductCompanyPlanList()
        }
      }
    }
  },
  methods: {
    changeCompany(index) {
      this.excessFormDataLock+= 1
      this.$set(this.item, 'plan_id', '')
    },
    changePlan() {
      this.excessFormDataLock += 1
      this.$emit('changePlan', this.currentPlanOptions)
    },
    async changeOtherProductCompanyPlanList(){
      const {class_id, company_id, trm_of_cvr,plan_type,plan_id} = this.item||{}
      let params = {
        class_id,
        company_id,
        plan_type,
        trm_of_cvr,
        merchant_platform:this.isFina?2:1
      }
      console.log('params--',params)
      let {data} = await getProductInsurersPlanList(params)
      let {plans=[]} = data||{}
      this.currentPlanList = plans||[]
      this.$set(this.item, 'plan_id', plan_id)
      this.$emit('changePlan',this.currentPlanList,this.index,this.item.plan_id)
      // this.formDataLock+=1
    },
    async validateForm(otherData) {
      let {quote_status} = this.item||{}
      let subForm = quote_status? this.subForm : {}
      Object.keys(subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if (Object.values(subForm).some(item => item === false)) {
        return
      }
      await new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, rules) => {
          if(valid) {
            this.parentOtherData = otherData
            if((this.isHouseMain||this.isDecoration||this.isHome)&&(quote_status&&this.editType==3||this.editType!=3)){
              if(this.isHouseMain){
                this.$refs['housemaid-excess-form'].submitForm()
              }
              if(this.isDecoration){
                this.$refs['docoration-excess-form'].submitForm()
              }
              if(this.isHome){
                this.$refs['homefire-excess-form'].submitForm()
              }
            }else
            {
              this.$emit('validate', otherData)
            }
            resolve(valid)
          }
          else {
            this.scrollToValidDom(rules)
            reject(valid)
          }
        })
      })
    }
  }
}